 // use a script tag or an external JS file
 document.addEventListener("DOMContentLoaded", (event) => {
  gsap.registerPlugin(ScrollTrigger, SplitText)

  //selecionar colunas pasrão do wp a esquerda e direta

// 1. Seleciona todos os containers pai
const containers = document.querySelectorAll('.wp-block-columns');

// 2. Cria os arrays vazios para guardar os resultados
const primeirasColunas = [];
const segundasColunas = [];

// 3. Passa por cada container uma única vez
containers.forEach(container => {
  const filhos = container.querySelectorAll(':scope > .wp-block-column');
  
  // Verifica se o container tem exatamente dois filhos
  if (filhos.length === 2) {
    // Separa e guarda nos seus respectivos arrays
    primeirasColunas.push(filhos[0]); // Índice 0 = Primeiro filho
    segundasColunas.push(filhos[1]);  // Índice 1 = Segundo filho
  } if (filhos.length >= 3) { //para três filhos ou mais
      gsap.from(container.querySelectorAll('.wp-block-column'), { 
        y: 100,
        opacity: 0,
        stagger: 0.2,
        duration: 0.5,
        scrollTrigger: {
          trigger: container,
          // scrub: true,
          start: 'top bottom', // when the top of the trigger hits the bottom of the viewport
          // end: 'top center', 
        }
      })
  }
});

// --- AGORA VOCÊ PODE USAR OS DOIS ARRAYS SEPARADAMENTE ---

// Manipulando apenas os primeiros filhos:
primeirasColunas.forEach(colunaEsq => {
  // coluna.classList.add('estilo-da-esquerda');
  const colunasEsq = gsap.utils.toArray(colunaEsq);
  colunasEsq.forEach(coluna => {
    gsap.from(coluna, { 
      x: -300,
      opacity: 0,
      duration: 0.5,
      scrollTrigger: {
        trigger: coluna,
        // scrub: true,
        start: 'top bottom', // when the top of the trigger hits the bottom of the viewport
        // end: 'top 50%', 
      }
    })
  });
});

// Manipulando apenas os segundos filhos:
segundasColunas.forEach(colunaDir => {
  const colunasDir = gsap.utils.toArray(colunaDir);
  colunasDir.forEach(coluna => {
    gsap.from(coluna, { 
      x: 300,
      opacity: 0,
      duration: 0.5,
      scrollTrigger: {
        trigger: coluna,
        // scrub: true,
        start: 'top bottom', // when the top of the trigger hits the top of the viewport
        // end: 'top center', 
      }
    })
  });
});
  
  // pega TODAS AS COLUNAS e entra pela esquerda
  const colunasEsq = gsap.utils.toArray('.column-esq');
  colunasEsq.forEach(coluna => {
    gsap.from(coluna, { 
      x: -300,
      opacity: 0,
      
      scrollTrigger: {
        trigger: coluna,
        // scrub: true,
        start: 'top bottom', // when the top of the trigger hits the bottom of the viewport
        // end: 'top center', 
        duration: 0.5,
      }
    })
  });

  // pega TODAS AS COLUNAS e entra pela direita
  const colunasDir = gsap.utils.toArray('.column-dir');
  colunasDir.forEach(coluna => {
    gsap.from(coluna, { 
      x: 300,
      opacity: 0,
      // duration: 0.5,
      scrollTrigger: {
        trigger: coluna,
        // scrub: true,
        start: 'top bottom', // when the top of the trigger hits the top of the viewport
        // end: 'top 70%', 
        duration: 0.5,
      }
    })
  });

 });

 // pega TODAS AS COLUNAS e entra por baixo
  const txtsUp = gsap.utils.toArray('.txt-up');
  txtsUp.forEach(txtUp => {
    gsap.from(txtUp, { 
      y: 100,
      opacity: 0,
      duration: 0.5,
      scrollTrigger: {
        trigger: txtUp,
        // scrub: true,
        start: 'top 90%', // when the top of the trigger hits the top of the viewport
        // end: 'top 70%', // end after scrolling 500px beyond the start
        // markers: true
        // duration: 0.5,
      }
    })
  });

var bannerHero = document.querySelector('.banner-hero__figure');
if(bannerHero) {
  gsap.to('.banner-hero__figure', { 
      scale: 1.2,
      duration: 1,
      scrollTrigger: {
        trigger: '.banner-hero__figure',
        scrub: true,
        start: 'top 130', // when the top of the trigger hits the top of the viewport
        // end: 'bottom middle', // end after scrolling 500px beyond the start
      }
    });
}

//INCENTIVO DO DIA

const txtSplit = gsap.utils.toArray('.split');
  txtSplit.forEach(split => {
SplitText.create(split, {
  type: "lines, words",
  mask: "lines",
  autoSplit: true,
  onSplit(self) {
    return gsap.from(self.words, {
      duration: 0.5, 
      y: 100, 
      autoAlpha: 0, 
      stagger: 0.05,
      scrollTrigger: {
        trigger: split,
        // markers: true,
        start: "top 90%",
        // end: "center 60%",
        // scrub: true
    }
    });
  }
});
});

//CARDS CARROSSEL HOVER

  var allCHover = document.querySelectorAll('.carrossel-hover');
  allCHover.forEach((cHover) => {
    gsap.from(cHover.querySelectorAll('.carrossel-hover-card'), { 
      y: 50,
      opacity: 0,
      stagger: 0.4,
      duration: 0.5,
      scrollTrigger: {
        trigger: cHover,
        // scrub: true,
        start: 'top bottom', // when the top of the trigger hits the top of the viewport
        // end: "top 40%", // end after scrolling 500px beyond the start
      }
    })
  });

//ITENS FAQ

  var allFaq = document.querySelectorAll('.destaque-faq__lista');
  allFaq.forEach((elFaq) => {
    gsap.from(elFaq.querySelectorAll('.destaque-faq__duvida'), { 
      x: 300,
      opacity: 0,
      stagger: 0.4,
      duration: 0.5,
      scrollTrigger: {
        trigger: elFaq,
        // scrub: true,
        start: 'top bottom', // when the top of the trigger hits the bottom of the viewport
        // end: 'top center', 
      }
    })
  });

  //SLIDESHOW
  // var allCardsSlideshow = document.querySelectorAll('.slideshow');

  //       allCardsSlideshow.forEach((cardSlideshow) => {
  //           // Seleciona todos os cartões dentro deste slideshow específico
  //           const cards = cardSlideshow.querySelectorAll('.slideshow-card');
            
  //           // Se não houver cartões, passa para o próximo
  //           if (cards.length === 0) return;

  //           // Criamos uma Timeline vinculada ao ScrollTrigger da seção (.slideshow)
  //           const tl = gsap.timeline({
  //               scrollTrigger: {
  //                   trigger: cardSlideshow,
  //                   duration: 0.8,
  //                   start: "top 50",      // Fixa quando o topo da seção encosta no topo da tela
  //                   // end: () => `+=${window.innerHeight * (cards.length - 1)}`, // Dinâmico: tamanho baseado no número de cards
  //                   scrub: true,           // Vincula a animação diretamente ao scroll do mouse
  //                   pin: true,             // Trava a seção inteira na tela enquanto os cards sobem
  //                   // markers: true,         // Mantive os marcadores para você testar
  //                   invalidateOnRefresh: true // Recalcula os valores se a tela mudar de tamanho
  //               }
  //           });

  //           // Animamos do segundo card em diante (índice i = 1)
  //           // O primeiro card (índice 0) já começa visível e parado na tela!
  //           for (let i = 1; i < cards.length; i++) {
  //               tl.from(cards[i], {
  //                   y: "100vh",       // Vem totalmente de fora da tela (pelo fundo)
  //                   // opacity: 0,       // Começa invisível
  //                   scale: 1,
  //                   duration: 1,      // Tempo relativo na timeline
  //                   ease: "none"      // Sem aceleração para o movimento ficar suave com o scroll
  //               }, "+=0.5");          // Um pequeno delay entre o fim de um card e o começo do outro
  //           }
  //       });

  var allCardsSlideshow = document.querySelectorAll('.slideshow');

allCardsSlideshow.forEach((cardSlideshow) => {
    const cards = cardSlideshow.querySelectorAll('.slideshow-card');
    
    if (cards.length === 0) return;

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: cardSlideshow,
            start: "top top",
            // Define a distância do scroll com base no número de cards
            end: () => `+=${window.innerHeight * (cards.length - 1)}`, 
            scrub: true,
            pin: true,
            invalidateOnRefresh: true
        }
    });

    for (let i = 1; i < cards.length; i++) {
        // 1. O próximo card vem de baixo
        tl.from(cards[i], {
            y: "100vh",
            duration: 1,
            ease: "none"
        }, "+=0.2")

        // 2. O card anterior diminui e desaparece SIMULTANEAMENTE (usando "<")
        .to(cards[i - 1], {
            scale: 0.85,    // Reduz ligeiramente o tamanho
            opacity: 0,     // Faz o card desaparecer
            duration: 1,
            ease: "none"
        }, "<");
    }
});

  //WP GRID

  var allWPGrid = document.querySelectorAll('.wp-block-group-is-layout-grid');
  allWPGrid.forEach((WPGrid) => {
    gsap.from(WPGrid.querySelectorAll('.is-layout-flex'), { 
      y: 50,
      opacity: 0,
      stagger: 0.2,
      duration: 0.5,
      scrollTrigger: {
        trigger: WPGrid,
        // scrub: true,
        start: 'top bottom', // when the top of the trigger hits the top of the viewport
        // end: "top 40%", // end after scrolling 500px beyond the start
      }
    })
  });

   //NOVIDADES

  var allNewsGrid = document.querySelectorAll('.novidades-lista');
  allNewsGrid.forEach((NewsGrid) => {
    gsap.from(NewsGrid.querySelectorAll('.post-card'), { 
      y: 50,
      opacity: 0,
      stagger: 0.2,
      duration: 0.5,
      scrollTrigger: {
        trigger: NewsGrid,
        // scrub: true,
        start: 'top bottom', // when the top of the trigger hits the top of the viewport
        // end: "top 40%", // end after scrolling 500px beyond the start
      }
    })
  });

  //PUBLICACOES

  var allPubliGrid = document.querySelectorAll('.publicacoes-list__grid');
  allPubliGrid.forEach((PubliGrid) => {
    gsap.from(PubliGrid.querySelectorAll('.post-card'), { 
      y: 50,
      opacity: 0,
      stagger: 0.2,
      duration: 0.5,
      scrollTrigger: {
        trigger: PubliGrid,
        // scrub: true,
        start: 'top bottom', // when the top of the trigger hits the top of the viewport
        // end: "top 40%", // end after scrolling 500px beyond the start
      }
    })
  });

  //PAG FAQ

  var allFaqList = document.querySelectorAll('.faq-grid');
  allFaqList.forEach((FaqList) => {
    gsap.from(FaqList.querySelectorAll('.faq-sanfona'), { 
      y: 50,
      opacity: 0,
      stagger: 0.2,
      duration: 0.5,
      scrollTrigger: {
        trigger: FaqList,
        // scrub: true,
        start: 'top bottom', // when the top of the trigger hits the top of the viewport
        // end: "top 40%", // end after scrolling 500px beyond the start
      }
    })
  });

  //FLOR DE LOTUS NO FOOTER

var florLotus = document.querySelector('.petala');

if (florLotus) {

const petalas = gsap.utils.toArray('.petala');

// Distribui o leque em 7 posições
const angulos = [-75, -50, -25, 0, 25, 50, 75]; 

gsap.set(petalas, { 
  transformOrigin: "50% 435px" 
});

const tl = gsap.timeline({
  duration: 0.8,
  scrollTrigger: {
    trigger: "svg",
    start: "top 80%",
    // end: "bottom 30%",
    // scrub: 1
  }
});

petalas.forEach((petala, index) => {
  tl.to(petala, {
    rotation: angulos[index],
    ease: "sine.out",
  }, 0);
});
}

window.addEventListener("load", () => {
  ScrollTrigger.refresh();
});